import { render, staticRenderFns } from "./DYAllianceAuthorization.vue?vue&type=template&id=0c60ceb6"
import script from "./DYAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./DYAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c60ceb6')) {
      api.createRecord('0c60ceb6', component.options)
    } else {
      api.reload('0c60ceb6', component.options)
    }
    module.hot.accept("./DYAllianceAuthorization.vue?vue&type=template&id=0c60ceb6", function () {
      api.rerender('0c60ceb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/DYAllianceAuthorization.vue"
export default component.exports